import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FieldType} from "../../fields3/field-type"
import Field1ToField2Converter from "../../fields3/fields-converter-1-2"
import FieldsFactory from "../../fields3/fields-factory"
import {EntityType} from "../../gd/const/item"
import FieldProto from "../../fields3/proto/field-proto";
import FieldCompanyUserWorkdayDuration from "../../fields3/system/user/workday-duration/workday-duration";
import FieldBreakDuration from "../../fields3/system/user/break-duration/break-duration";
import FieldCompanyUserWorkSchedule from "../../fields3/system/user/work-schedule/work-schedule";
import FieldDepartment from "../../fields3/generic/department/department";
import FieldCompanyUserSkills from "../../fields3/system/user/skills/skills";
import FieldCompanyUserRole from "../../fields3/system/user/company-role/company-role";
import CompanyUser from "./company-user";
import {CompanyRole} from "../../gd/const/company-role";
import FieldCheckbox from "../../fields3/generic/boolean/checkbox/checkbox";
import FieldUser from "../../fields3/generic/user/user";
import FieldCompanyUserRequiredReportTime from "../../fields3/system/user/required-report-time/required-report-time";
import FieldEmail from "../../fields3/generic/info/email/email"
import {GroupedData} from "../../data-structures/group"
import FieldNumber from "../../fields3/generic/number/number"
import FieldTimeOfDay from "../../fields3/generic/datetime/time-of-day/time-of-day";

const getBaseConfig = () => {

    const departmentOptions : Option[] = gd.session.departments.filterByCompany(gd.companyId).exportToOptions()


    const companyUsers : CompanyUser[] = gd.session.companyUsers.findAllByCompanyRoles([CompanyRole.MANAGER, CompanyRole.USER])
    const reportToOptions : Option[] = companyUsers.map((cu:CompanyUser)=>{
        if (!cu.user) {
            console.warn("#ldjdhj293 no company user found")
        }
        return {
            value   : cu.userId,
            label   : cu.user?.name
        }
    })


    // DAILY BADGE TIME REPORT
    const bailyBadgeTimeReportOptions = [
        {label: 'Yes',  value: true},
        {label: 'No',   value: false}
    ]

// DAILY BADGE COMMON DROPDOWN OPTIONS
    const dropdownOptions = [
        {value: -1,     label: "Don't check"},
        {value: 24,     label: "1 day"},
        {value: 48,     label: "2 days"},
        {value: 72,     label: "3 days"},
        {value: 96,     label: "4 days"},
        {value: 120,    label: "5 days"},
        {value: 144,    label: "6 days"},
        {value: 168,    label: "1 week"},
    ];

    const baseConfig = [
        {fieldId: 'name',           label: 'Name',          type: FieldType.STRING},
        {
            fieldId         : 'companyRole',
            label           : 'Company Role',
            type            : FieldType.COMPANY_USER_ROLE},
        {
            fieldId         : 'departmentId',
            label           : 'Department',
            type            : FieldType.DROPDOWN,
            options         : departmentOptions,
            noValueOption   : false,
            showMenuMore    : false,
            icon            : 'i5-departments'
        },
        {
            fieldId             : 'reportToUserId',
            label               : 'Report to',
            type                : FieldType.USER,
            options             : reportToOptions,
            noValueOptionLabel  : 'Nobody',
            placeholder         : 'Nobody'
        },
        {fieldId: 'isAdmin',                    label: 'Admin',                 type: FieldType.CHECKBOX},
        {fieldId: 'isActivated',                label: 'Activated',             type: FieldType.CHECKBOX},
        // {fieldId: 'userId',                     label: 'User',                  type: FieldType.USER},

        {
            fieldId     : 'workSchedule',
            label       : 'Work Schedule',
            type        : FieldType.COMPANY_USER_WORK_SCHEDULE
        },
        {
            fieldId: 'requiredTimeReportMinutes',
            label: 'Required report time',
            type: FieldType.COMPANY_USER_REQUIRED_REPORT_TIME
        },

        {
            fieldId : 'email',
            label   : 'Primary email',
            type    : FieldType.EMAIL
        },

        {
            fieldId     : 'skills',
            label       : 'Skills',
            type        : FieldType.COMPANY_USER_SKILLS
        },

        {
            fieldId             : 'autoClockOutTime',
            label               : 'Auto clock out time',
            type                : FieldType.TIME_OF_DAY,
            noValueOption       : true,
            noValueOptionLabel  : 'Auto (workday duration)',
            placeholder         : 'Auto (workday duration)',
            addNoValueOption    : true,

            description         : 'The time when an automatic clock-out will be recorded if the user has not clocked out. If not set, it will calculate automatically based on a user\'s workday duration.',



        },




        // do we still neeed it ???
        {
            fieldId     : 'workdayDuration',
            label       : 'Work day duration',
            type        : FieldType.COMPANY_USER_WORKDAY_DURATION
        },

        {fieldId: 'defaultBreakDuration',       label: 'Break duration',        type: FieldType.BREAK_DURATION},

        {fieldId: 'guesstimate',                label: 'Guesstimate',           type: FieldType.TOGGLE},
        {fieldId: 'isDailyBadgeEnabled',        label: 'Daily badge',           type: FieldType.TOGGLE},
        {
            fieldId             : 'dailyBadgeTimeReport',
            type                : FieldType.DROPDOWN,
            options             : bailyBadgeTimeReportOptions,
            addNoValueOption    : false,
            showMenuMore        : false,
        },

        {
            fieldId             : 'eventPastDue',
            type                : FieldType.DROPDOWN,
            options             : dropdownOptions,
            addNoValueOption    : false,
            showMenuMore        : false,
        },
        {
            fieldId             : 'taskAssignedDeadline',
            type                : FieldType.DROPDOWN,
            options             : dropdownOptions,
            addNoValueOption    : false,
            showMenuMore        : false,
        },
        {
            fieldId             : 'taskAssignedBehindSchedule',
            type                : FieldType.DROPDOWN,
            options             : dropdownOptions,
            addNoValueOption    : false,
            showMenuMore        : false,
        },
        {
            fieldId             : 'taskARNotScheduled',
            type                : FieldType.DROPDOWN,
            options             : dropdownOptions,
            addNoValueOption    : false,
            showMenuMore        : false,
        },
        {fieldId: 'internal',   label: 'Internal cost', type: FieldType.NUMBER},
        {fieldId: 'external',   label: 'External cost', type: FieldType.NUMBER},
    ]

    return baseConfig
}

// const debug = "CompanyUserFields"
const debug = false

export default class CompanyUserFields extends FieldsCollection {

    get workSchedule()          { return this.get('workdayDurations') as FieldCompanyUserWorkSchedule }
    get workdayDuration()       { return this.get('workdayDuration') as FieldCompanyUserWorkdayDuration }
    get breakDuration()         { return this.get('defaultBreakDuration')   as FieldBreakDuration }
    get departmentId()          { return this.get('departmentId')   as FieldDepartment }
    get autoClockOutTime()      { return this.get('autoClockOutTime')   as FieldTimeOfDay }
    get skills()                { return this.get('skills') as FieldCompanyUserSkills }
    get companyRole()           { return this.get('companyRole') as FieldCompanyUserRole }
    get reportToUserId()        { return this.get('reportToUserId') as FieldUser }
    get isAdmin()               { return this.get('isAdmin') as FieldCheckbox }
    get isActivated()           { return this.get('isActivated') as FieldCheckbox }
    get requiredTimeReport()    { return this.get('requiredTimeReportMinutes') as FieldCompanyUserRequiredReportTime }
    get email()                 { return this.get('email') as FieldEmail }
    get internalCost()      : FieldNumber { return this.get('internal') as FieldNumber }
    get externalCost()      : FieldNumber { return this.get('external') as FieldNumber }

    constructor(options:any = {}) {
        const fieldsConfig = CompanyUserFields.getFieldsConfig(options)

        debug && console.log(debug, 'constructor', fieldsConfig)

        super(fieldsConfig, EntityType.COMPANY_USER)
    }

    get name(): FieldProto {
        return this.get('name')
    }

    private static getFieldsConfig(options:any = {}) {
        let customFieldsConfig : any = []
        if (options.customFieldsIds) {
            _.map(options.customFieldsIds, customFieldId=>{
                const field2Config = Field1ToField2Converter.getField2Config(customFieldId)
                if (field2Config) customFieldsConfig.push(field2Config)
            })
        } else {
            _.map(gd.company.settings.modules.companyUsers.customFields.slice(), customFieldConfig=>{
                customFieldConfig.isCustom = true
                customFieldsConfig.push(customFieldConfig)
            })
        }

        const baseConfig = getBaseConfig()

        debug && console.log(debug, 'getFieldsConfig', options, baseConfig, customFieldsConfig)

        return _.union(baseConfig, customFieldsConfig)
    }

    reset(options:any) {
        const fieldsConfig = CompanyUserFields.getFieldsConfig(options)

        this._fields = []

        _.map(fieldsConfig, fieldConfig=>{
            this.addField(FieldsFactory.get(fieldConfig))
        })
    }

    structureFilterFields(customFields?: any[]): GroupedData {

        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.name,
                    this.companyRole,
                    this.departmentId,
                    this.email,
                    this.reportToUserId,
                    this.isAdmin,
                    this.isActivated,
                    this.requiredTimeReport,
                    this.skills,
                    this.internalCost,
                    this.externalCost
                ]
            },
            {
                value   : 'custom-fields',
                label   : 'Custom',
                type    : 'custom-fields',
                items   : _.filter(this._fields, (field: FieldProto) => {
                    return field.isCustom && field.isFilterAvailable
                })
            }
        ]
    }

    debug() {
        _.map(this._fields, field=>{
            console.log(field.fieldId)
        })
    }
}
